import $ from "jquery";
import alertify from "alertifyjs";
import Swal from "sweetalert2";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

// Retrieve the token from localStorage
const token = localStorage.getItem("access_token");

// Redirect to login if token is not present

export function addToCart(itemId, event, itemType) {
  const addToCartBtn = $(event.target); // Wrap the button element as a jQuery object

  addToCartBtn
    .addClass("disabled")
    .html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> جاري الإضافة...'
    );

  let addUrl;
  const requestData = {};
  if (itemType === "bundle") {
    requestData.bundle_id = itemId;
    addUrl = `${apiUrl}/addtocart/bundle?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  }
  if (itemType === "course") {
    requestData.course_id = itemId;
    addUrl = `${apiUrl}/addtocart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  }

  /*$.ajax({
    url: addUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    success: function (response) {
      console.log("Item added to cart successfully!");
      alertify.success("تم الإضافة الى السلة بنجاح");
      showCart();
      //$("#cartModal").modal("show");
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", error);
      console.log(xhr.responseText);
      const responseText = xhr.responseText;
      if (responseText === '  "Course is already in cart !"') {
        alertify.error("هذه الدورة موجودة في السلة مسبقاً");
      } else if (responseText !== '  "Course is already in cart !"') {
        alertify.error("Error adding item to cart");
      }
    },
    complete: function () {
      addToCartBtn
        .removeClass("disabled")
        .html("إضافة إلى السلة <i class='fas fa-cart-plus'></i>");
    },
  });*/
  $.ajax({
    url: addUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    success: function (response, textStatus, xhr) {
      // التحقق مما إذا كان الرد يحتوي على محتوى صفحة تسجيل الدخول
      if (response.includes("login") || response.includes("تسجيل الدخول")) {
        // إذا كانت الاستجابة تحتوي على محتوى صفحة تسجيل الدخول
        console.log("Redirected to login page.");
        var myModal = new bootstrap.Modal(
          document.getElementById("loginModal")
        );
        myModal.show();

        showCart(); // عرض نافذة تسجيل الدخول
      } else {
        // إذا كانت الاستجابة صحيحة، أي أن العنصر قد أضيف إلى السلة بنجاح
        console.log("Item added to cart successfully!");
        alertify.success("تم الإضافة الى السلة بنجاح");
        showCart();
        //$("#cartModal").modal("show");
      }
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", error);
      console.log(xhr.responseText);

      // التحقق من حالة الريسبونس في حال حدوث خطأ
      if (xhr.status === 302 || xhr.status === 204) {
        $("#loginModal").modal("show"); // عرض نافذة تسجيل الدخول
      } else {
        const responseText = xhr.responseText;
        if (responseText === '  "Course is already in cart !"') {
          alertify.error("هذه الدورة موجودة في السلة مسبقاً");
        } else {
          alertify.error("Error adding item to cart");
        }
      }
    },
    complete: function () {
      addToCartBtn
        .removeClass("disabled")
        .html("إضافة إلى السلة <i class='fas fa-cart-plus'></i>");
    },
  });
}
export function showCart() {
  let ImagePath;
  $.ajax({
    url: `${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    success: function (response, textStatus, xhr) {
      if (response.cart && response.cart.length != 0) {
        const cartItems = response.cart;
        let tableRowsBundle = "";
        let tableRowsCourse = "";
        let couponExists = false;
        let couponApplied = false;
        for (let i = 0; i < cartItems.length; i++) {
          const cartItem = cartItems[i];
          let couponDetails = "";
          if (cartItem.cart_coupon) {
            couponExists = true;
            const coupon = cartItem.cart_coupon;
            const discountValue =
              coupon.discount_type === "PERCENTAGE"
                ? `${coupon.total_discount}%`
                : `${coupon.total_discount} د.ل`;
            couponDetails = `Coupon:  Discount: ${discountValue}`;
          } else {
            //couponDetails = "No coupon applied";
            couponDetails = "";
          }

          if (cartItem.course_id == null) {
            ImagePath = `${baseUrl}/images/bundle/`;
            const row = `<tr data-bundle-id='${cartItem.bundle_id}'>
            <td>${i + 1}</td>
            <td><img class='rounded' src='${ImagePath}${
              cartItem.bundle.preview_image
            }' alt='Thumbnail' style='width: 70px; height: 70px;'></td>
            <td>${cartItem.bundle.title}</td>
            <td><b class="text-success">${couponDetails}</b></td>
            <td><span class="amount-cart">${cartItem.price} د.ل</span></td>
            <td><button style="padding:5px 7px" class='remove-button btn btn-sm btn-dark' data-bundle-id='${
              cartItem.bundle_id
            }'><i class='fa fa-close'></i></button></td>
          </tr>`;
            tableRowsBundle += row;
          } else {
            ImagePath = `${baseUrl}/images/course/`;
            const row = `<tr data-course-id='${cartItem.course_id}'>
            <td>${i + 1}</td>
            <td><img class='rounded' src='${ImagePath}${
              cartItem.courses.preview_image
            }' alt='Thumbnail' style='width: 70px; height: 70px;'></td>
            <td>${cartItem.courses.title}</td>
            <td><b class="text-success">${couponDetails}</b></td>
            <td><span class="amount-cart">${cartItem.price} د.ل</span></td>
            <td><button class='remove-button btn btn-sm btn-dark' style="padding:5px 8px" data-course-id='${
              cartItem.course_id
            }'><i class='fa fa-close'></i></button></td>
          </tr>`;
            tableRowsCourse += row;
          }
        }

        $("#cartTableBodyBundle").html(tableRowsBundle);
        $("#cartTableBodyCourse").html(tableRowsCourse);
        $(".cart-tb").show();
        $(".remove-button").click(function () {
          const bundleId = $(this).data("bundle-id");
          const courseId = $(this).data("course-id");
          removeCartItem(bundleId, courseId);
        });

        if (couponExists) {
          const removeButton = $(
            '<button class="p-3 btn btn-danger btn-sm btn-block waves-effect waves-light" type="button">   إزالة الكوبون <i class="fa fa-trash"></i> </button>'
          );
          removeButton.appendTo($("#removeCouponContainer"));
          removeButton.on("click", removeCoupon);
          $(".addCoupon").hide();
        } else {
          $(".addCoupon").show();

          $("#removeCouponContainer").empty();
        }
      } else {
        var empt = ` <div class="col-12">
            <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-inboxes"></i></span>
            <h3 class="mb-4">        سلتك فارغة    </h3>
           
          </div>
        </div>`;
        $(".cartContent").html(empt);
      }
    },
    error: function (xhr, status, error) {
      console.error("Error retrieving cart:", error);
    },
  });
}

export function removeCartItem(bundleId, courseId) {
  let removeUrl = `${apiUrl}/remove/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  const requestData = {};
  let removeButton;
  if (bundleId) {
    requestData.bundle_id = bundleId;
    removeUrl = `${apiUrl}/remove/bundle?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
    removeButton = $(
      `#cartTableBodyBundle button[data-bundle-id='${bundleId}']`
    );
  }
  if (courseId) {
    requestData.course_id = courseId;
    removeButton = $(
      `#cartTableBodyCourse button[data-course-id='${courseId}']`
    );
  }
  removeButton
    .addClass("disabled")
    .html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );
  $.ajax({
    url: removeUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    success: function (response) {
      if (bundleId) {
        $(`#cartTableBodyBundle tr[data-bundle-id='${bundleId}']`).remove();
      } else if (courseId) {
        $(`#cartTableBodyCourse tr[data-course-id='${courseId}']`).remove();
      }
      const cartInvoiceTable = $("#cartInvoiceTable");
      generateCartInvoice(cartInvoiceTable);
    },
    complete: function () {
      removeButton.removeClass("disabled").text("إضافة إلى السلة");
    },
    error: function (xhr, status, error) {
      console.error("Error removing item from cart:", error);
    },
  });
}

export function generateCartInvoice(cartInvoiceTable) {
  $("#offerPercentCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $("#couponDiscountCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $("#totalPriceCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $.ajax({
    url: `${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      $("#loader").addClass("spinner-border text-primary");
    },
    success: function (response) {
      if (response.cart) {
        console.log("Cart data retrieved successfully:", response);

        // Calculate total price and coupon discount
        let totalPrice = 0;
        let couponDiscount = 0;

        response.cart.forEach((cartItem) => {
          totalPrice += parseFloat(cartItem.price);
          if (cartItem.cart_coupon) {
            const coupon = cartItem.cart_coupon;
            if (coupon.discount_type === "PERCENTAGE") {
              couponDiscount +=
                (parseFloat(cartItem.price) * coupon.total_discount) / 100;
            } else {
              couponDiscount += coupon.total_discount;
            }
          }
        });

        const finalPrice = totalPrice - couponDiscount;

        $("#offerPercentCell").html(`${response.offer_percent}%`);
        $("#couponDiscountCell").html(`${couponDiscount.toFixed(2)} د.ل`);
        $("#totalPriceCell").html(
          `${response.cart_total - couponDiscount.toFixed(2)} د.ل`
        );
        $("#loader").removeClass("spinner-border text-primary");
      }
    },
    error: function (xhr, status, error) {
      console.error("Error retrieving cart:", error);
      $("#loader").removeClass("spinner-border text-primary");
    },
  });
}

// src/utils/cart.js
// src/utils/cart.js
export function applyCoupon(couponCode, button) {
  button
    .prop("disabled", true)
    .html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );

  $.ajax({
    url: `${apiUrl}/apply/coupon/v2?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    data: { coupon: couponCode },
    success: function (response) {
      if (response && response.errors && response.errors.coupon) {
        alertify.error(response.errors.coupon[0]);
      } else {
        alertify.success("Coupon applied successfully!");
        $("#applyCouponModal").modal("hide");
        location.reload();
      }
      // إرجاع الزر إلى حالته الطبيعية
      button
        .prop("disabled", false)
        .html('تطبيق <i class="mdi mdi-gift-outline"></i>');
    },
    error: function (xhr, status, error) {
      alertify.error(`Failed to apply coupon: ${error}`);
      // إرجاع الزر إلى حالته الطبيعية
      button
        .prop("disabled", false)
        .html('تطبيق <i class="mdi mdi-gift-outline"></i>');
    },
  });
}

export function removeCoupon() {
  Swal.fire({
    title: "هل أنت متأكد؟",
    text: "لن تتمكن من التراجع عن هذا!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "نعم، قم بإزالة الكوبون!",
    cancelButtonText: "إلغاء",
  }).then((result) => {
    if (result.isConfirmed) {
      $.ajax({
        url: `${apiUrl}/remove/coupon/v2?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
        method: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        success: function (response) {
          Swal.fire("تم الإزالة!", "تمت إزالة الكوبون بنجاح.", "success").then(
            () => {
              location.reload();
            }
          );
        },
        error: function (xhr, status, error) {
          Swal.fire("خطأ!", `فشل في إزالة الكوبون: ${error}`, "error");
        },
      });
    }
  });
}

export function confirmPurchase(button) {
  Swal.fire({
    title: "هل أنت متأكد من إستكمال عملية الشراء",
    text: "  ",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3ddc97",
    cancelButtonColor: "#f46a6a",
    cancelButtonText: "لا",
    confirmButtonText: "نعم",
  }).then(function (result) {
    if (result.isConfirmed) {
      button
        .prop("disabled", true)
        .html(
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...'
        );
      $.ajax({
        url: `${apiUrl}/pay/store/v4?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
        method: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        success: function (response) {
          Swal.fire({
            title: "تم عملية الشراء بنجاح",
            text: "نتمنى لك التوفيق.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/Dashboard";
            }
          });
          console.log(response);
        },
        error: function (xhr, status, error) {
          Swal.fire(
            "توجد مشكلة الرجاء التأكد وإعادة المحاولة",
            "الرجاء التحقق من رصيدك.. إذا استمرت الرجاء التواصل معنا",
            "error"
          );
          button
            .prop("disabled", false)
            .html('تأكيد الشراء <i class="mdi mdi-check"></i>');
        },
      });
    }
  });
}
